import TitleBlock from '@anm/components/TitleBlock';
import { FC } from 'react';

import LinkItem from './LinkItem';
import { CardModalWrapper, LinkContainer } from './Wrapper';

export type TwoOptionsDialogProps = {
  editorLink: string;
  studioLink: string;
  onStudioOpen: () => void;
  onEditorOpen: () => void;
  onModalClose: () => void;
};

const TwoOptionsDialog: FC<TwoOptionsDialogProps> = ({
  editorLink,
  studioLink,
  onEditorOpen,
  onStudioOpen,
  onModalClose
}) => (
  <CardModalWrapper onModalClose={onModalClose}>
    <TitleBlock direction="center" size="medium" color="black" title="Welcome aboard!" />
    <LinkContainer>
      <LinkItem
        src="images/streaming/on-board-live.png"
        link={studioLink}
        title="Open live streaming studio"
        onClick={onStudioOpen}
      />
      <LinkItem
        src="images/streaming/on-board-editor.png"
        link={editorLink}
        title="Open sample video project"
        onClick={onEditorOpen}
      />
    </LinkContainer>
  </CardModalWrapper>
);

export default TwoOptionsDialog;
